<template>
    <div class="start-modal">
        <el-dialog v-model="modelValueState" @closed="$emit('closed')" :show-close="false">
            <template #header>
                <CloseModalButton @click="modelValueState = false" />
            </template>

            <el-row v-show="successMessage">
                <div class="success-wrapper">{{ successMessage }}</div>
            </el-row>

            <el-row>
                <el-col :span="24" class="title-col">
                    <div>Bitte Vakanz auswählen</div>
                </el-col>
            </el-row>

            <el-row class="start-modal-content">
                <el-col :span="24">
                    <el-input v-model="search" placeholder="Suchen..." clearable style="margin-bottom: 10px;"
                        class="searcher">
                        <template #suffix>
                            <img src="/media/images/search_gray.png" alt="Search"
                                style="width: 16px; height: 16px; opacity: 0.6;" />
                        </template>
                    </el-input>

                    <EasyDataTable :headers="headers" :items="vacancies" :rows-per-page="5" :search-value="search"
                        class="table table-striped dataTable" table-class-name="vacancies-table" buttons-pagination>
                        <template #item-action="{ id, name }">
                            <el-button type="primary" @click="handleAdd(id, name)"
                                class="add-candidates-to-vacancy-btn">
                                <CirclePlusIcon />
                            </el-button>
                        </template>
                    </EasyDataTable>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24" class="title-col">
                    <div>{{ $trans('web_search.checkout_start_modal.your_selection_of_candidates') }}</div>
                </el-col>
            </el-row>

            <el-row class="your-selection-content">
                <el-col>
                    <div class="tag-header">
                        <span class="color-grey">Suchbegriffe</span>
                    </div>
                    <div class="match-rate-header">
                        <span class="color-grey">Match Rate</span>
                    </div>

                    <div v-for="(profile, index) in CandidateBoardStore.getProfiles()" :key="index"
                        class="your-selection-row">
                        <div><img :src="profile.avatar_url" /></div>

                        <div>
                            <template v-for="(filter, index) in profile.activeTerms" :key="index">
                                <Tag size="small" :text="filter.name" />
                            </template>
                            <template v-for="(filter, index) in profile.activeFilters" :key="index">
                                <Tag size="small" :text="filter" />
                            </template>
                        </div>

                        <div class="match-rate">
                            <div>
                                <span class="color-black">{{ profile.percentage_score_avg }}</span>
                                <span class="color-grey"> / 100</span>
                            </div>
                        </div>

                        <div class="action">
                            <el-icon color="white" @click="CandidateBoardStore.removeFromBoard(profile.id)">
                                <DeleteIcon />
                            </el-icon>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import { Delete as DeleteIcon } from '@element-plus/icons-vue'
import { CirclePlus as CirclePlusIcon } from '@element-plus/icons-vue'
import { mapStores } from 'pinia'
import { useCandidateBoardStore } from '@/stores/CandidateBoardStore'


import CloseModalButton from './CloseModalButton';
import StartModalSide from './StartModalSide';
import Tag from './../Utils/Tag';
import EasyDataTable from 'vue3-easy-data-table'


export default {
    props: ['modelValue', 'groupName'],
    emits: ['update:modelValue', 'validated', 'closed'],
    components: {
        EasyDataTable,
        CloseModalButton,
        StartModalSide,
        DeleteIcon,
        CirclePlusIcon,
        Tag,
    },
    data() {
        return {
            modelValueState: false,
            message: false,
            successMessage: false,
            vacancies: [],
            currentPage: 1,
            pageSize: 5,
            search: '',
            headers: [
                { text: "Vacancy Name", value: "name", sortable: true },
                { text: "Client", value: "client", sortable: true },
                { text: "Consultant", value: "consultant", sortable: true },
                { text: "Highest Candidate Status", value: "highest_candidate_status", sortable: true },
                { text: "Action", value: "action", sortable: false },
            ],
        };
    },
    computed: {
        ...mapStores(useCandidateBoardStore), // useCandidateBoardStore => this.CandidateBoardStore
    },
    methods: {
        async getVacancies() {
            try {
                const response = await fetch('/ajax-get-vacancies-for-web-search-internal');
                const result = await response.json();
                if (result.status === 'success') {
                    this.vacancies = result.data;
                }
            } catch (error) {
                console.error('Error fetching vacancies:', error);
            }
        },
        async handleAdd(vacancyId, vacancyName) {
            try {
                const profileIds = this.CandidateBoardStore.getProfiles().map(p => p.id);

                if (profileIds.length === 0) {
                    console.warn('No candidates selected.');
                    return;
                }

                const response = await fetch('/ajax-add-candidates-to-vacancies-from-web-search-internal', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        vacancy_id: vacancyId,
                        profile_ids: profileIds,
                        _token: document.head.querySelector('meta[name="csrf-token"]').content,
                    })
                });

                const result = await response.json();

                if (result.status === 'success') {
                    this.successMessage = `${profileIds.length} candidates have been added to vacancy "${vacancyName}"`;

                    setTimeout(() => {
                        this.successMessage = false;
                    }, 5000);
                } else {
                    this.successMessage = 'Error: ' + (result.message || 'Unknown error');
                }
            } catch (error) {
                console.error('Request error:', error);
            }
        }
    },
    watch: {
        modelValue: function () {
            this.modelValueState = this.modelValue;
            this.message = false;
            if (this.modelValue) {
                this.getVacancies();
            }
        },
    },
}
</script>

<style scoped>
.start-modal :deep(.el-dialog) {
    --el-dialog-width: 800px;
    background-color: #ededed;
    top: -100px !important;
}

.center {
    text-align: center;
}

.success-wrapper {
    text-align: center;
    font-weight: bold;
    width: 100%;
    color: #135d23;
    background-color: #d3f0d9;
    border-color: #c2eaca;
    padding: 11px;
}

.error-wrapper {
    color: #FF6B65;
    font-style: italic;
}

.start-modal :deep(.el-dialog .el-dialog__header) {
    padding-bottom: 0;
}

.start-modal :deep(.el-form--default.el-form--label-top .el-form-item .el-form-item__label) {
    margin-bottom: 0px;
}

.start-modal .el-row {
    color: rgb(60, 60, 60);
    padding-bottom: 18px;
}

.start-modal .el-row:first-child {
    padding-top: 18px;
}

.start-modal .el-row:nth-child(3) {
    margin-top: 20px;
    padding-top: 18px;
}

.start-modal .el-col {
    padding: 0 15px;
}

.start-modal .title-col div {
    text-align: left;
    font: normal normal 500 24px/29px Barlow;
    letter-spacing: -0.24px;
    color: #3C3C3C;
    padding-top: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid rgb(60, 60, 60);
}

.start-modal-content>div:nth-child(2) {
    max-width: 40%;
    flex: 0 0 40%;
}

.start-modal .el-button {
    border-radius: 4px;
    height: 40px;
    width: 100%;
    max-width: 600px;
    font-size: 18px;
    font-weight: 300;
}

.start-modal .el-button:not(.el-button--info) {
    background-color: #41ABC4;
    color: #fff;
}

.start-modal .el-button:not(.el-button--info):hover {
    background-color: #2699b2;
}

.your-selection-content {
    display: block;
    max-height: 300px;
    overflow-y: auto;
}

.your-selection-row {
    display: flex;
    padding: 8px 16px;
}

.your-selection-row:not(:last-child) {
    padding-bottom: 4px;
    border-bottom: 1px solid rgb(60, 60, 60);
}

.your-selection-row>div:nth-child(1)>img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
}

.your-selection-row>div:nth-child(2) {
    flex-grow: 1;
    padding: 5px 15px;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    overflow-y: hidden;
}

.your-selection-row>div:nth-child(4) {
    display: flex;
    align-items: center;
}

.your-selection-row>div:nth-child(4):first-child {
    margin-top: -55px;
}

.your-selection-row>div:nth-child(4)>.el-icon {
    background-color: #41ABC4;
    padding: 10px;
    width: 42px;
    height: 42px;
    border-radius: 10px;
    background-image: linear-gradient(#ff6b65 0 0);
    background-size: 100% .0em;
    background-repeat: no-repeat;
    transition: 0.1s;
}

.your-selection-row>div:nth-child(4)>.el-icon:hover {
    transition: 0.1s;
    background-size: 100% 100%;
    cursor: pointer;
}

.your-selection-row>div:nth-child(4)>.el-icon>svg {
    width: 22px;
    height: 22px;
}

.match-rate {
    font-size: 20px;
    min-width: 120px;
}

.tag-header {
    margin-left: 113px;
    font-weight: bold;
    font-size: 18px;
}

.match-rate-header {
    margin-left: 558px;
    bottom: 25px;
    position: relative;
    font-weight: bold;
    font-size: 18px;
}

.add-candidates-to-vacancy-btn svg {
    width: 30px;
    margin-left: 10px;
}

.add-candidates-to-vacancy-btn {
    border-color: #41ABC4;
    padding-left: 0px;
    padding-right: 10px;
}

@media only screen and (max-width: 500px) {
    .your-selection-content {
        max-height: unset;
    }

    .your-selection-row {
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .your-selection-row>div:nth-child(2) {
        order: 3;
        padding: 10px 0;
        width: 100%;
    }
}

/* max-wdith = width of modal + 50px */
@media only screen and (max-width: 850px) {
    .el-dialog {
        position: fixed;
        z-index: 100;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 8px;
        width: calc(100% - 30px);
        margin: 15px;
        box-sizing: border-box;
        overflow-y: scroll;
    }

    .start-modal :deep(.el-dialog) {
        --el-dialog-width: 95%;
    }

    .start-modal-content>div:nth-child(1) {
        max-width: 100%;
        flex: 0 0 100%;
    }

    .start-modal-content>div:nth-child(2) {
        display: none;
    }
}

@media only screen and (max-width: 790px) {
    .match-rate-header {
        margin-left: unset;
        bottom: 27px;
    }

    .tag-header .color-grey {
        margin-left: -108px;
    }

    .match-rate-header .color-grey {
        margin-left: 44%;
    }

    .match-rate {
        min-width: 75px;
    }
}

.searcher {
    height: 40px;
    width: 295px;
    font-weight: 600;
}

:deep(.el-input__wrapper.is-focus) {
    border: 2px solid #41ABC4 !important;
}

:deep(.pagination__rows-per-page) {
    display: none !important;
}

:deep(.vue3-easy-data-table__footer) {
    justify-content: center !important;
}


.vacancies-table {
    --easy-table-header-font-size: 14px;
    --easy-table-body-row-font-size: 14px;

    --easy-table-body-row-hover-background-color: #fff;
}



/* DTABLE TABLE */
:deep(.vue3-easy-data-table) {
    margin-bottom: unset !important;
}

:deep(.vue3-easy-data-table tr td) {
    height: 1px;
}

:deep(.vue3-easy-data-table tr th),
:deep(.vue3-easy-data-table tr td) {
    border: 2px solid #ededed;
}


:deep(.vue3-easy-data-table tr td) {
    background: #ffffff;
    padding: 0.5rem;
    line-height: 20px;
}

:deep(.vue3-easy-data-table tr th) {
    border-top: 0;
    border-bottom: 0;
    background: rgb(237, 237, 237);
    padding: 0 0.5rem;
    color: #3C3C3C;
    font-style: normal;
    font-weight: 200;
    font-size: 14px;
    height: 24px;
    line-height: 24px;
    font-family: sans-serif;
    border-top: unset;
}

:deep(.vue3-easy-data-table__body tr:hover td:last-child) {
    background-color: #d2e1e5 !important;
}

:deep(.vue3-easy-data-table) {
    border: none !important;
}

:deep(.vue3-easy-data-table__footer) {
    background-color: transparent !important;
}

:deep(.vue3-easy-data-table__body tr td:last-child) {
    background-color: #d2e1e5;
}

:deep(.pagination__items-index) {
    display: none !important;
}

:deep(.el-input__prefix) {
    width: 0 !important;
}

:deep(.el-input__wrapper) {
    border-radius: 0 !important;
}

:deep(.buttons-pagination .item.button.active) {
    color: #fff;
    background: linear-gradient(90deg, rgb(65, 171, 196) 0%, rgb(119, 214, 241) 100%);
    border-color: rgb(65, 171, 196);
    border-radius: 0;
}

:deep(.buttons-pagination .item.button) {
    border-radius: 0;
}

:deep(.buttons-pagination) {
    --40dd4f07: unset !important;
    transform: scale(1.5);
    margin-top: 25px;
}

:deep(.vue3-easy-data-table__main) {
    background-color: #ededed;
}

:deep(.next-page__click-button .arrow) {
    margin-top: 21px;
    margin-left: 40px;
}

:deep(.previous-page__click-button .arrow) {
    margin-right: 40px;
    margin-top: 21px;
}
</style>
